module.exports = __webpack_public_path__ + "static/assets/a143370353ea213f3eb2ca018f2205dd.jpg";